export const AdminAccountSummary = ({ currentUser }) => (
  <div className="admin-account-summary">
    <div className="admin-account-icon" aria-hidden="true">
      <i className="bi bi-person-circle" />
    </div>
    <div className="admin-account-details">
      <span className="admin-account-label">Signed in as</span>
      <span className="admin-account-email">{currentUser.username}</span>
      <span className="admin-account-role">{currentUser.role}</span>
    </div>
  </div>
);
